import "antd/lib/dropdown/style";
import _Dropdown from "antd/lib/dropdown";
import "antd/lib/card/style";
import _Card from "antd/lib/card";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/tooltip/style";
import _Tooltip from "antd/lib/tooltip";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.function.name.js";
import { TeamOutlined } from '@ant-design/icons';
import React, { useState } from 'react';
import { Auth } from '@aws-amplify/auth';
import handleError from 'utils/http/handleError';
import validateInput, { rules } from 'utils/validateInputs';
import endUserMessages from 'utils/endUserMessages';
import pushNotificationMessage from 'utils/pushNotificationMessage';
import fetchAPI from 'utils/http/fetchAPI';
var initialMessage = 'Hi,\n\nCheck out Trailmaker. It will make your single-cell analysis easier.';
var ReferralButton = function ReferralButton(props) {
  var collapsed = props.collapsed;
  var _useState = useState(false),
    visible = _useState[0],
    setVisible = _useState[1];
  var _useState2 = useState(''),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = useState(false),
    isEmailValid = _useState3[0],
    setIsEmailValid = _useState3[1];
  var _useState4 = useState(initialMessage),
    customMessage = _useState4[0],
    setCustomMessage = _useState4[1];
  var submitReferral = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var user, userContext, referralData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setVisible(false);
              _context.prev = 1;
              _context.next = 4;
              return Auth.currentAuthenticatedUser();
            case 4:
              user = _context.sent;
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              console.warn('User not authenticated');
            case 10:
              userContext = user ? [{
                type: 'mrkdwn',
                text: '*From:*'
              }, {
                type: 'mrkdwn',
                text: user.attributes.name
              }, {
                type: 'mrkdwn',
                text: '*Email:*'
              }, {
                type: 'plain_text',
                text: user.attributes.email
              }, {
                type: 'mrkdwn',
                text: '*Domain:*'
              }, {
                type: 'plain_text',
                text: window.location.hostname
              }, {
                type: 'mrkdwn',
                text: '*User UUID:*'
              }, {
                type: 'plain_text',
                text: user.username
              }] : [];
              referralData = {
                channel: 'referrals',
                blocks: [{
                  type: 'section',
                  text: {
                    type: 'plain_text',
                    text: "To: ".concat(email)
                  }
                }, {
                  type: 'section',
                  text: {
                    type: 'plain_text',
                    text: "Message:\n ".concat(customMessage)
                  }
                }, {
                  type: 'divider'
                }, {
                  type: 'context',
                  elements: [].concat(userContext)
                }]
              };
              _context.prev = 12;
              _context.next = 15;
              return fetchAPI('/v2/sendSlackMessage', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  data: referralData
                })
              });
            case 15:
              setEmail('');
              setCustomMessage(initialMessage);
              pushNotificationMessage('success', endUserMessages.REFERRAL_SUCCESSFUL);
              _context.next = 23;
              break;
            case 20:
              _context.prev = 20;
              _context.t1 = _context["catch"](12);
              handleError(_context.t1, endUserMessages.REFERRAL_ERROR);
            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 7], [12, 20]]);
    }));
    return function submitReferral() {
      return _ref.apply(this, arguments);
    };
  }();
  var menuItems = [{
    label: __jsx(_Card, {
      size: "small",
      style: {
        padding: '1em',
        width: '300px'
      }
    }, __jsx(_Space, {
      direction: "vertical",
      style: {
        width: '100%'
      }
    }, "Provide your colleague's email address to recommend Trailmaker.", __jsx(_Input, {
      label: "Email",
      onChange: function onChange(e) {
        var _validateInput = validateInput(e.target.value, rules.VALID_EMAIL),
          isValid = _validateInput.isValid;
        setIsEmailValid(isValid);
        setEmail(e.target.value);
      },
      placeholder: 'Your friend\'s email address'
    }), __jsx(_Space, null, __jsx(_Button, {
      size: "small",
      onClick: function onClick() {
        return setVisible(false);
      }
    }, "Cancel"), __jsx(_Tooltip, {
      title: !isEmailValid ? 'Please enter a valid email address' : ''
    }, __jsx(_Button, {
      size: "small",
      type: "primary",
      disabled: !isEmailValid,
      onClick: submitReferral
    }, "Send invite"))), "Note that Insights projects can be shared with collaborators to enable them to explore projects that you own.", __jsx("br", null), "To do this, use the Share button in", __jsx("a", {
      target: "_blank",
      href: "/data-management",
      rel: "noreferrer"
    }, "Insights."))),
    key: 'referral-button-contents',
    title: ''
  }];
  return __jsx(_Dropdown, {
    open: visible,
    onOpenChange: function onOpenChange(v) {
      return setVisible(v);
    },
    menu: {
      items: menuItems
    },
    placement: "topRight",
    trigger: "click"
  }, __jsx(_Button, {
    type: "text",
    icon: __jsx(TeamOutlined, null),
    style: {
      color: 'hsla(0, 0%, 100%, .65)'
    }
  }, !collapsed && 'Recommend'));
};
export default ReferralButton;